export default "__VITE_ASSET__BnpTk0aG__"